var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select"},[_c('select',{attrs:{"name":_vm.name,"required":_vm.required},domProps:{"value":_vm.value},on:{"change":_vm.onchanges}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }